import { render, staticRenderFns } from "./BtnSelecionarTodosItensRequisicaoRateio.vue?vue&type=template&id=5c1589e8&"
import script from "./BtnSelecionarTodosItensRequisicaoRateio.vue?vue&type=script&lang=js&"
export * from "./BtnSelecionarTodosItensRequisicaoRateio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports